import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@mui/material/Typography';
import {Divider} from '@mui/material';
import InfoItemBox from './InfoItemBox';
import { InfoItemBoxProps } from '../dataObjects/contentTypes';


const content: InfoItemBoxProps[] = [
{
  title: "How to take OCPF Treasurer Training Course",
  blocks: [ 
    {
      type: "list",
      listType: "bullet",
      items: [
        {
          content: [
            { type: "text", content: "The campaign finance law requires new treasurers to complete online treasurer training within 30 days of becoming a treasurer." }
          ]
        },
        {
          content: [
            { type: "text", content: "Massachusetts campaign finance regulations require treasurers who e-file with OCPF to complete online treasurer training during the first six months of odd-numbered years." }
          ]
        },
        {
          content: [
            { type: "text", content: "OCPF’s treasurer training program is available in Reporter 7 at " },
            { type: "link", text: "this link", url: "https://www.ocpfreporter.us/Account/LogOn" },
            { type: "text", content: " . Once the committee has organized with OCPF, the committee treasurer should log on to Reporter 7, and click the “tools” tile. To start the training, choose the “treasurer training” tile." }
          ]
        }
       
      ]
    },
    {
      type: "paragraph",
      content: [
        {
          type: 'image',
          src: '/treasurer_training.jpg',
          alt: 'OCPF Online Treasurer Training',
          link: 'https://www.ocpfreporter.us/TreasurerTraining/Index'}
      ]
    },
    {
      type: "list",
      listType: "bullet",
      items: [
        {
          content: [
              { type: "text", content: "Training takes about 15 minutes." }
              ]
          },
          {
              content: [
                  { type: "text", content: "Local party committee treasurers are not required to complete on-line training." }
                  ]
              }
      ]
    }
  ]
}
];

const TreasurerTrainingInfo = (): JSX.Element => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });


  return (
      <div>
        
        <Typography
              component="h1"
              variant="h4"
              align={'left'}
              data-aos={'fade-up'}
              gutterBottom
              sx={{
                fontWeight: 700,
              }}
              paddingTop={4}>
              OCPF Treasurer Training
            </Typography>

            <Divider />
         {content.map((content, index) => (
          <InfoItemBox key={index} {...content} />
        ))}
      </div>
       
   
        
  );
};

export default TreasurerTrainingInfo;
